// extracted by mini-css-extract-plugin
export default {"root":"Pw62u","link-overlay":"_3BmPr","linkOverlay":"_3BmPr"};